export default {"src":"/_next/static/media/couch_40.a41e961e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};